import { RecordHistory } from './RecordHistory';

/** Beschriftungen für Felder, die in mehreren Bereichen vorkommen. Was hier fehlt, erscheint mit seinem Schlüssel. */
const FIELD_LABELS: Record<string, string> = {
  name: 'Name', email: 'E-Mail', phone: 'Telefon', street: 'Straße', postalCode: 'Postleitzahl', city: 'Ort', note: 'Notiz', companyId: 'Firma', relationTypeIds: 'Beziehungen',
  sku: 'Artikelnummer', kind: 'Art', description: 'Beschreibung', salePriceCents: 'Verkaufspreis', purchasePriceCents: 'Einkaufspreis', taxRate: 'Steuersatz', unitId: 'Einheit',
  categoryId: 'Kategorie', tagIds: 'Schlagworte', active: 'Aktiv', isActive: 'Aktiv', status: 'Stand', title: 'Titel', subject: 'Betreff', plate: 'Kennzeichen', make: 'Marke', model: 'Modell',
  validUntil: 'Gültig bis', dueDate: 'Fällig am', startsAt: 'Beginn', endsAt: 'Ende', location: 'Ort', amountCents: 'Betrag', balanceCents: 'Guthaben', number: 'Nummer',
};
const ACTION_LABELS: Record<string, string> = {
  create: 'Angelegt', delete: 'Gelöscht', archive: 'Archiviert', restore: 'Wiederhergestellt', merge: 'Mit einem anderen Eintrag zusammengeführt', merged_into: 'In einen anderen Eintrag überführt',
  image_add: 'Bild hinzugefügt', image_remove: 'Bild entfernt', image_reorder: 'Bilder neu angeordnet', cancel: 'Abgebrochen', send: 'Versendet', issue: 'Ausgestellt', accept: 'Angenommen', reject: 'Abgelehnt',
};

function short(value: unknown): string {
  if (value === null || value === undefined || value === '') return 'leer';
  if (typeof value === 'boolean') return value ? 'ja' : 'nein';
  if (typeof value === 'string') return `„${value.length > 40 ? `${value.slice(0, 40)}…` : value}“`;
  if (typeof value === 'number') return String(value);
  return '';
}

/** Wortlaut einer Änderung: „Geändert: Name von „A“ auf „B“, Telefon“. Aufgelistet sind die geänderten Felder, bei einfachen Werten mit altem und neuem Stand. */
function describe(action: string, data: Record<string, unknown>): string {
  if (action === 'update') {
    const list = Array.isArray(data.fields) ? (data.fields as unknown[]).map(String) : Object.keys(data);
    const parts = list.map((key) => {
      const label = FIELD_LABELS[key] ?? key;
      const change = data[key] as { from?: unknown; to?: unknown } | undefined;
      if (change && typeof change === 'object' && 'to' in change && !Array.isArray(change.from) && !Array.isArray(change.to) && typeof change.from !== 'object' && typeof change.to !== 'object') {
        return `${label} von ${short(change.from)} auf ${short(change.to)}`;
      }
      return label;
    });
    return parts.length ? `Geändert: ${parts.join(', ')}` : 'Geändert';
  }
  return ACTION_LABELS[action] ?? action.replace(/_/g, ' ');
}

/**
 * Verlauf eines Datensatzes („Wer hat wann was geändert?“) aus dem Änderungsprotokoll. `entity` ist der Schlüssel im Protokoll, zum Beispiel „contact“. Der Server entscheidet, ob der
 * Benutzer den Verlauf sehen darf (GET /audit/:entity/:id). Für Belege mit eigenen Sätzen (Rechnungen, Aufträge, Mitarbeiter) gibt es eigene Verläufe.
 */
export function EntityHistory({ entity, id }: { entity: string; id: string }) {
  return <RecordHistory path={`/audit/${entity}/${id}`} queryKey={['audit', entity, id]} labels={{}} storageKey={`history-${entity}`} fallback={describe} />;
}
